import React from 'react';
import { motion } from 'framer-motion';

export default function ProgressBar({ value = 0, max = 100, delay = 0, height = 6, showLabel = false }) {
  const pct = max > 0 ? Math.min((value / max) * 100, 100) : 0;

  let fillGradient;
  if (pct > 90) {
    fillGradient = 'linear-gradient(90deg, #DC1F26, #F87171)';
  } else if (pct > 70) {
    fillGradient = 'linear-gradient(90deg, #F59E0B, #FCD34D)';
  } else {
    fillGradient = 'linear-gradient(90deg, #3B82F6, #00C2FF)';
  }

  return (
    <div style={{ width: '100%' }}>
      <div style={{
        background: 'rgb(var(--fg) / 0.06)',
        borderRadius: height,
        overflow: 'hidden',
        height,
        position: 'relative',
      }}>
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay }}
          style={{
            height: '100%',
            borderRadius: height,
            background: fillGradient,
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {pct > 90 && (
            <div style={{
              position: 'absolute', inset: 0,
              background: 'linear-gradient(90deg, transparent 0%, rgb(var(--fg) / 0.15) 50%, transparent 100%)',
              backgroundSize: '200px 100%',
              animation: 'shimmer 1.8s linear infinite',
            }} />
          )}
        </motion.div>
      </div>
      {showLabel && (
        <div style={{ fontSize: '11px', color: pct > 90 ? '#F87171' : pct > 70 ? '#FCD34D' : '#60A5FA', marginTop: '3px', textAlign: 'right' }}>
          {Math.round(pct)}%
        </div>
      )}
    </div>
  );
}
